<template>
    <div>
        <div class="w-full">
            <div>
                <label>{{ step.label }}</label>
                <input @input="updateParentValue" v-model.trim="inputData" class="input-styling"  type="text" :placeholder="step.placeholder">
            </div> 
        </div>
        <div class="error-text-styling">
            <div v-if="displayErrorMessage">
                {{step.errorMessage}}
            </div>
        </div>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';


export default {
    props: ['step', 'value'],
    data() {
        return {
            inputData: '',
            dirty: false,
        }
    },
    validations: {
        inputData: {
            required,
            minLength: minLength(2)
        }
    },
    computed: {
        invalidData() {
            return this.$v.inputData.$invalid;
        },
        displayErrorMessage() {
            return this.dirty && this.invalidData
        }
    },
    methods: {
        updateParentValue(e){
            this.dirty = true;
            this.$emit("input", {'value': this.inputData, 'valid': !this.$v.inputData.$invalid}) 
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
